import React from 'react';
import leafImage from '../assets/leaf.png';
import childImage from '../assets/child_with_trolley.jpg';

// Custom styles for Session component
const styles = `
.session-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 80px 0;
}

/* Decorative circle - Top Right */
.session-circle-top-right {
    position: absolute;
    top: -80px;
    right: -80px;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay - Top Right */
.session-leaf-top-right {
    position: absolute;
    top: -60px;
    right: -60px;
    width: 240px;
    height: 240px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

/* Decorative circle - Bottom Left */
.session-circle-bottom-left {
    position: absolute;
    bottom: 40px;
    left: -120px;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay - Bottom Left */
.session-leaf-bottom-left {
    position: absolute;
    bottom: 60px;
    left: -100px;
    width: 260px;
    height: 260px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

.session-content-wrapper {
    position: relative;
    z-index: 3;
}

/* Hours Section */
.session-hours-row {
    display: flex;
    align-items: flex-start;
    gap: 50px;
    margin-bottom: 60px;
}

.session-hours-content {
    flex: 1;
}

.session-hours-image-wrapper {
    flex: 0 0 400px;
    max-width: 400px;
    align-self: stretch;
    display: flex;
}

.session-hours-image-container {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    width: 100%;
    position: relative;
}

.session-hours-image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    object-fit: cover;
    object-position: center;
}

/* Headings */
.session-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.8rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 20px;
}

/* Text */
.session-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.75;
    margin-bottom: 20px;
}

/* We offer label */
.session-offer-label {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    font-weight: 700;
    color: #5A3411;
    margin-bottom: 10px;
}

/* Session list */
.session-list {
    list-style: none;
    padding: 0;
    margin: 0 0 20px 0;
    font-weight: bold;
}

.session-list-item {
    font-family: 'Quicksand', sans-serif;
    font-size: 1rem;
    font-weight: 700;
    color: #5A3411;
    line-height: 1.6;
    margin-bottom: 5px;
    padding-left: 20px;
    position: relative;
}

.session-list-item::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #5A3411;
    font-weight: 700;
}

/* Fees Section */
.session-fees-section {
    padding-left: 50px;
}

.session-fees-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.4rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 20px;
}

.session-fees-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.75;
    margin-bottom: 25px;
}

/* Contact Button */
.session-btn {
    background-color: #FF800D;
    color: white;
    font-family: 'Quicksand', sans-serif;
    font-size: 1rem;
    font-weight: 600;
    padding: 12px 35px;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.session-btn:hover {
    background-color: #e67300;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 128, 13, 0.3);
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .session-section {
        padding: 70px 0;
    }
    
    .session-heading {
        font-size: 2.5rem;
    }
    
    .session-fees-heading {
        font-size: 2.2rem;
    }
    
    .session-hours-image-wrapper {
        flex: 0 0 350px;
        max-width: 350px;
    }
    
    .session-hours-row {
        gap: 40px;
    }
    
    .session-circle-top-right {
        width: 220px;
        height: 220px;
        top: -70px;
        right: -70px;
    }
    
    .session-leaf-top-right {
        width: 190px;
        height: 190px;
        top: -50px;
        right: -50px;
    }
    
    .session-circle-bottom-left {
        width: 250px;
        height: 250px;
        left: -100px;
    }
    
    .session-leaf-bottom-left {
        width: 220px;
        height: 220px;
        left: -80px;
    }
    
    .session-fees-section {
        padding-left: 30px;
    }
}

@media (max-width: 991.98px) {
    .session-section {
        padding: 60px 0;
    }
    
    .session-heading {
        font-size: 2.2rem;
    }
    
    .session-fees-heading {
        font-size: 2rem;
    }
    
    .session-hours-row {
        flex-direction: column;
        gap: 35px;
    }
    
    .session-hours-content {
        width: 100%;
    }
    
    .session-hours-image-wrapper {
        flex: 0 0 auto;
        max-width: 450px;
        width: 100%;
        align-self: center;
        order: -1;
    }
    
    .session-hours-image-container {
        height: auto;
        position: static;
    }
    
    .session-hours-image {
        position: static;
        height: auto;
    }
    
    .session-text,
    .session-fees-text {
        font-size: 1rem;
    }
    
    .session-circle-top-right {
        width: 180px;
        height: 180px;
        top: -60px;
        right: -60px;
    }
    
    .session-leaf-top-right {
        width: 150px;
        height: 150px;
        top: -40px;
        right: -40px;
    }
    
    .session-circle-bottom-left {
        width: 200px;
        height: 200px;
        left: -90px;
    }
    
    .session-leaf-bottom-left {
        width: 170px;
        height: 170px;
        left: -70px;
    }
    
    .session-fees-section {
        padding-left: 0;
    }
}

@media (max-width: 767.98px) {
    .session-section {
        padding: 50px 0;
    }
    
    .session-heading {
        font-size: 1.8rem;
        margin-bottom: 18px;
    }
    
    .session-fees-heading {
        font-size: 1.7rem;
    }
    
    .session-hours-row {
        gap: 30px;
        margin-bottom: 50px;
    }
    
    .session-hours-image-wrapper {
        max-width: 380px;
    }
    
    .session-text,
    .session-fees-text {
        font-size: 0.95rem;
        line-height: 1.7;
        margin-bottom: 15px;
    }
    
    .session-offer-label {
        font-size: 1rem;
    }
    
    .session-list-item {
        font-size: 0.95rem;
    }
    
    .session-circle-top-right {
        width: 140px;
        height: 140px;
        top: -50px;
        right: -50px;
    }
    
    .session-leaf-top-right {
        width: 120px;
        height: 120px;
        top: -35px;
        right: -35px;
    }
    
    .session-circle-bottom-left {
        width: 160px;
        height: 160px;
        left: -70px;
    }
    
    .session-leaf-bottom-left {
        width: 140px;
        height: 140px;
        left: -55px;
    }
    
    .session-hours-image-container {
        border-radius: 16px;
    }
    
    .session-btn {
        padding: 10px 30px;
        font-size: 0.95rem;
    }
}

@media (max-width: 575.98px) {
    .session-section {
        padding: 40px 0;
    }
    
    .session-heading {
        font-size: 1.5rem;
        margin-bottom: 15px;
    }
    
    .session-fees-heading {
        font-size: 1.4rem;
    }
    
    .session-hours-row {
        gap: 25px;
        margin-bottom: 40px;
    }
    
    .session-hours-image-wrapper {
        max-width: 320px;
    }
    
    .session-text,
    .session-fees-text {
        font-size: 0.9rem;
        line-height: 1.65;
        margin-bottom: 12px;
    }
    
    .session-offer-label {
        font-size: 0.95rem;
    }
    
    .session-list-item {
        font-size: 0.9rem;
        padding-left: 15px;
    }
    
    .session-circle-top-right {
        width: 110px;
        height: 110px;
        top: -40px;
        right: -40px;
    }
    
    .session-leaf-top-right {
        width: 95px;
        height: 95px;
        top: -28px;
        right: -28px;
    }
    
    .session-circle-bottom-left {
        width: 130px;
        height: 130px;
        left: -60px;
    }
    
    .session-leaf-bottom-left {
        width: 110px;
        height: 110px;
        left: -48px;
    }
    
    .session-hours-image-container {
        border-radius: 14px;
    }
    
    .session-btn {
        padding: 10px 25px;
        font-size: 0.9rem;
    }
}

@media (max-width: 400px) {
    .session-section {
        padding: 35px 0;
    }
    
    .session-heading {
        font-size: 1.3rem;
    }
    
    .session-fees-heading {
        font-size: 1.2rem;
    }
    
    .session-hours-image-wrapper {
        max-width: 280px;
    }
    
    .session-text,
    .session-fees-text {
        font-size: 0.85rem;
    }
    
    .session-list-item {
        font-size: 0.85rem;
    }
    
    .session-circle-top-right {
        width: 90px;
        height: 90px;
        top: -35px;
        right: -35px;
    }
    
    .session-leaf-top-right {
        width: 75px;
        height: 75px;
        top: -22px;
        right: -22px;
    }
    
    .session-circle-bottom-left {
        width: 100px;
        height: 100px;
        left: -45px;
    }
    
    .session-leaf-bottom-left {
        width: 85px;
        height: 85px;
        left: -35px;
    }
    
    .session-hours-image-container {
        border-radius: 12px;
    }
    
    .session-btn {
        padding: 8px 22px;
        font-size: 0.85rem;
    }
}
`;

const Session = () => {
    const sessions = [
        "Full Day: 7:30 am - 6:00 pm",
        "Morning: 7:30 am - 12:30 pm",
        "Afternoon: 1:00 pm - 6:00 pm"
    ];

    return (
        <>
            <style>{styles}</style>
            <section className="session-section">
                {/* Decorative Circle - Top Right */}
                <div className="session-circle-top-right"></div>
                {/* Decorative Leaf - Top Right */}
                <div
                    className="session-leaf-top-right"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>
                {/* Decorative Circle - Bottom Left */}
                <div className="session-circle-bottom-left"></div>
                {/* Decorative Leaf - Bottom Left */}
                <div
                    className="session-leaf-bottom-left"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>

                <div className="container">
                    <div className="session-content-wrapper">
                        {/* Hours & Sessions Section */}
                        <div className="row">
                            <div className="col-12">
                                <div className="session-hours-row">
                                    {/* Text Content */}
                                    <div className="session-hours-content">
                                        <h2 className="session-heading">Hours & Sessions</h2>

                                        <p className="session-text">
                                            Zubis Nursery is open Monday to Friday, 7:30 am - 6:00 pm, for 51 weeks a year (closed on bank holidays and one week at Christmas).
                                        </p>

                                        <p className="session-offer-label">We offer:</p>
                                        <ul className="session-list">
                                            {sessions.map((session, index) => (
                                                <li key={index} className="session-list-item fw-bold">{session}</li>
                                            ))}
                                        </ul>

                                        <p className="session-text">
                                            Please contact a member of our management team to discuss available sessions and enrolment options.
                                        </p>
                                    </div>

                                    {/* Image */}
                                    <div className="session-hours-image-wrapper">
                                        <div className="session-hours-image-container">
                                            <img
                                                src={childImage}
                                                alt="Child playing with trolley"
                                                className="session-hours-image"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Fees Section */}
                        <div className="row">
                            <div className="col-12 col-lg-8 offset-lg-2">
                                <div className="session-fees-section">
                                    <h2 className="session-fees-heading">Fees</h2>

                                    <p className="session-fees-text">
                                        Nursery fees are payable monthly in advance, on the first of each month, based on 51 weeks per year, including bank holidays. We accept childcare vouchers from all approved schemes, including tax credits. For full fee details, please contact our management team.
                                    </p>

                                    <a href="/contact" className="session-btn">Contact Us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Session;
